import { ICON_NAMES, IconName } from "../../../packages/blueprint-ui/src/components/Icon/types";

export function getIconName(icon: { selectionValues: { key: IconName }[] }) {
  return ICON_NAMES.includes(icon.selectionValues[0].key) ? icon.selectionValues[0].key : "check-thin";
}
